import { useState } from "react";
import { newsList } from "@/mocks/news";
import { useSeo } from "@/hooks/useSeo";
import NewsCard from "@/components/feature/NewsCard";

const PAGE_SIZE = 4;

export default function News() {
  const [visible, setVisible] = useState(PAGE_SIZE);

  useSeo(
    "榴莲视频 - 影视资讯频道",
    "榴莲视频影视资讯频道，提供最新的电影、电视剧、综艺行业动态、幕后故事与深度剧评。",
    "榴莲视频,影视资讯,影视新闻,行业动态,剧评,幕后",
  );

  const shown = newsList.slice(0, visible);

  return (
    <>
      <section className="border-b border-background-200/60 bg-background-100/40">
        <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
          <nav className="mb-4 flex items-center gap-2 text-xs text-foreground-400">
            <span className="text-foreground-700">首页</span>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700">影视资讯</span>
          </nav>
          <div className="flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-500 text-background-50">
              <i className="ri-newspaper-line text-2xl"></i>
            </span>
            <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">影视资讯</h1>
          </div>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-400 md:text-base">
            汇聚行业动态、深度剧评、幕后花絮与综艺观察，用更专业的视角帮你在海量内容里快速找到值得关注的那一条。
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-8 md:py-14">
        <div className="mb-4 text-sm text-foreground-300">
          共 <span className="text-accent-500">{newsList.length}</span> 条资讯 · 当前显示 {shown.length} 条
        </div>

        {shown.length > 0 ? (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-2 lg:gap-6">
            {shown.map((item, i) => (
              <div key={item.id} className={`animate-fade-up delay-${(i % 4) + 1}`}>
                <NewsCard item={item} />
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center rounded-lg border border-background-200/60 bg-background-100/40 py-16 text-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200/70 text-foreground-300">
              <i className="ri-article-line text-3xl"></i>
            </span>
            <p className="mt-4 font-heading text-lg text-foreground-950">暂无资讯内容</p>
            <p className="mt-1 text-sm text-foreground-400">我们正在整理新的文章，敬请期待</p>
          </div>
        )}

        {shown.length < newsList.length && (
          <div className="mt-8 flex justify-center">
            <button
              type="button"
              onClick={() => setVisible((v) => v + PAGE_SIZE)}
              className="flex items-center gap-2 rounded-md border border-background-300/70 px-6 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-foreground-950 cursor-pointer whitespace-nowrap"
            >
              加载更多
              <i className="ri-arrow-down-line"></i>
            </button>
          </div>
        )}
      </div>
    </>
  );
}